module.exports = "/_next/static/images/b81f20a81a1c094b76703a4c5bba76a0-nubanker-xpeer@0.5x.jpg.webp";